import { render, staticRenderFns } from "./DelegationRateGroupSelect.vue?vue&type=template&id=7880b39a&scoped=true&"
import script from "./DelegationRateGroupSelect.vue?vue&type=script&lang=js&"
export * from "./DelegationRateGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880b39a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7880b39a')) {
      api.createRecord('7880b39a', component.options)
    } else {
      api.reload('7880b39a', component.options)
    }
    module.hot.accept("./DelegationRateGroupSelect.vue?vue&type=template&id=7880b39a&scoped=true&", function () {
      api.rerender('7880b39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomInputComponents/DelegationRateGroupSelect.vue"
export default component.exports